/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import MicrosoftTeamsRegularAi from './microsoft-teams-regular-ai-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <MicrosoftTeamsRegularAi {...validProps} />;
}
SvgComponent.iconName = 'microsoftTeamsRegularAi';

export const MicrosoftTeamsRegularAiIcon = svgIconWrapper(SvgComponent);
